import { Expose, Type } from 'class-transformer'
import { Package } from 'react-feather'

import { Audit } from './Audit'
import { Place } from './Place'

export class AuditResultPlace {
  static type = 'auditresultplace'
  static typeDisplay = 'Audit Result Place'
  static icon = Package

  type = AuditResultPlace.type
  typeDisplay = AuditResultPlace.typeDisplay
  icon = AuditResultPlace.icon

  get guid () {
    return `${this.audit.guid}-${this.place.guid}`
  }

  @Type(() => Audit)
  audit: Audit = new Audit()

  @Type(() => Place)
  place: Place = new Place()

  @Expose({ name: 'over_count' })
  over?: number

  @Expose({ name: 'under_count' })
  under?: number

  @Expose({ name: 'match_count' })
  match?: number

  @Expose({ name: 'accuracy_score' })
  accuracyScore?: number
}
